import React, { useState, useEffect } from 'react';
import classes from './DropDownModal.module.css';
import CheckIconWhite from '../../../assets/icons/check-white.svg';



export default function DropDownModal(props) {
    const [activeItem, setActiveItem] = useState(props.itemClicked);
    const onItemClick = (pos) => {
        if (pos === null) {
            setActiveItem(pos);
            props.handleClick(-1);
        }
        else {
            setActiveItem(pos);
            props.handleClick(pos);
        }
    }

    useEffect(() => {
        if (props.itemClicked === -1) {
            setActiveItem(props.itemClicked);
        }
    }, []);

    const Select = <div>{props.itemList.map((item, i) => {
        return (
            <div key={i} onClick={() => onItemClick(i)} className={[classes.ListItem, props.forTemplateForm ? classes.RalewayFont : ''].join(' ')}>
                <div className={[classes.CheckIconDiv, classes.Round,
                i === activeItem ? classes.ActiveCheckIcon : null].join(' ')}>
                    <img src={CheckIconWhite} alt="Option Checked Icon" className={[classes.CheckIcon,
                    i === activeItem ? classes.ShowImage : null].join(' ')} />
                </div>
                {item.label ? item.label : item.name}</div>
        )
    })}</div>

    const Checkbox = <div>{props.itemList.map((item, i) => {
        return (
            <div key={i} onClick={() => onItemClick(i)} className={[classes.ListItem, props.forTemplateForm ? classes.RalewayFont : ''].join(' ')}>
                <div className={[classes.CheckIconDiv, classes.Square,
                (item.selected) ? classes.ActiveCheckIcon : null].join(' ')}>
                    <img src={CheckIconWhite} alt="Option Checked Icon" className={[classes.CheckIcon,
                    (item.selected) ? classes.ShowImage : null].join(' ')} />
                </div>
                {item.label ? item.label : item.name}</div>
        )
    })}</div>

    return (
        <div className={props.modalOpen ? classes.ModalOpen : classes.ModalClose}>
            <span className={classes.ModalHeader}>
                <span className={classes.ModalTitle}>{props.title}</span>
                {props.clear ? <span className={classes.Clear} onClick={() => onItemClick(null)} >Clear</span> : null}
            </span>
            <span className={classes.Options}>
                {props.multiple ? Checkbox : Select}
            </span>
        </div>
    );
}
